'use strict';

var _ = require('lodash');
var FlightTagsTooltipFactory = function FlightTagsTooltipFactory() {
  var HIDE_DELAY = 50;
  var SHOW_DELAY = 50;
  function FlightTagsTooltip() {}
  FlightTagsTooltipFactory.constructor = FlightTagsTooltip;
  function getHtmlContent(cellData) {
    var tooltipData = {
      flightTags: _.split(cellData.value, ',')
    };
    var tooltipContent = _.template(require('../templates/flight-tags-tooltip.html'));
    return tooltipContent(tooltipData);
  }
  FlightTagsTooltip.prototype.getBuilder = function () {
    return function (cellData, wholeGridData) {
      if (cellData.value) {
        return {
          htmlContent: getHtmlContent(cellData, wholeGridData),
          hideDelay: HIDE_DELAY,
          showDelay: SHOW_DELAY,
          placement: 'top'
        };
      } else {
        return '';
      }
    };
  };
  return FlightTagsTooltip;
};
module.exports = FlightTagsTooltipFactory;